import {
  getLegitChecks as getLegitChecksCall,
  postLegitCheck as postLegitCheckCall,
} from "./api/legitCheckService";
import NotificationService from "../components/Notification/notificationService";
import LoginService from "./loginService";
import { LegitCheckItem } from "../types/types";

export default function LegitCheckService() {
  const { error: errorNotification } = NotificationService();
  const { setLogout } = LoginService();

  const handleError = (status: number, description: string) => {
    if (status === 401) {
      setLogout();
    } else {
      errorNotification(description);
    }
  };

  const getLegitChecks = async (item_id: number) => {
    let response = await getLegitChecksCall(item_id).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });

    if (response?.data) {
      const data: Array<LegitCheckItem> = response.data.data;

      return data;
    } else {
      return undefined;
    }
  };
  const postLegitCheck = async (
    item_id: number,
    comment: string,
    is_legit: boolean,
  ) => {
    let response = await postLegitCheckCall(item_id, comment, is_legit).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      },
    );

    if (response?.data) {
      return true;
    } else {
      return undefined;
    }
  };

  return {
    getLegitChecks,
    postLegitCheck,
  };
}
